
import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import LandingPage from '@/components/LandingPage';
import TestEmailButton from '@/components/recruiter-feedback/TestEmailButton';
import { Button } from '@/components/ui/button';
import { RefreshCw, AlertCircle } from 'lucide-react';
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { useAuth } from '@/context/AuthContext';

const Index = () => {
  const [buildTimestamp, setBuildTimestamp] = useState<string>('');
  const { user } = useAuth();
  
  useEffect(() => {
    // Récupérer le timestamp de la construction depuis la console
    console.log('Page index chargée. Vérification de version...');
    const appVersion = localStorage.getItem('app_version') || 'non définie';
    setBuildTimestamp(appVersion);
  }, []);

  // Si l'utilisateur est connecté, rediriger vers le tableau de bord
  if (user) {
    return <Navigate to="/dashboard" replace />;
  }

  const handleClearSession = () => {
    console.log('Réinitialisation de la session...');
    localStorage.clear(); // Nettoyer tout le localStorage
    sessionStorage.clear(); // Nettoyer tout le sessionStorage
    
    // Forcer le rechargement complet sans cache
    window.location.href = window.location.origin + '?clear_session=true&t=' + new Date().getTime();
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow">
        <LandingPage />
        
        {/* Placement du bouton de test dans un conteneur plus discret */}
        <div className="container mx-auto py-8 text-center">
          <div className="max-w-md mx-auto p-6 border rounded-xl bg-gray-50 shadow-sm">
            <h3 className="text-lg font-medium mb-4">Administration</h3>
            <div className="mb-4">
              <TestEmailButton />
            </div>
            
            <div className="mt-6 pt-4 border-t border-gray-200">
              <Alert className="mb-4 bg-blue-50 border-blue-200">
                <AlertCircle className="h-4 w-4 text-blue-600" />
                <AlertTitle className="text-blue-800">Problèmes d'affichage?</AlertTitle>
                <AlertDescription className="text-blue-700">
                  Si le contenu n'est pas à jour, utilisez le bouton ci-dessous.
                  {buildTimestamp && (
                    <div className="text-xs mt-1 text-gray-500">Version actuelle: {buildTimestamp}</div>
                  )}
                </AlertDescription>
              </Alert>
              
              <Button 
                onClick={handleClearSession}
                variant="default"
                size="sm"
                className="w-full bg-blue-600 hover:bg-blue-700 text-white"
              >
                <RefreshCw className="mr-2 h-4 w-4 animate-spin-slow" />
                Forcer le rechargement complet
              </Button>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Index;
